import React from 'react'
import { Box, Button, Heading, Text } from 'grommet'
import APersonCard from './APersonCard'

const PersonList = (props: any) => {
    // console.log('PersonList', props)
    const personData = props.personData
    return (
        <>
            {personData ?
                <Box
                    width="full"
                    height="full"
                    overflow="auto"
                    pad="10px"
                    background="rgba(255,255,255,0.8)"
                    align="start" justify="start"
                >
                    {personData.map((p: any) => (
                        <APersonCard
                            key={p.person.person_id}
                            person={p.person}
                            names={p.names}
                        />
                    ))}
                </Box>:<Box
                    width="full"
                    height="full"
                    overflow="auto"
                    pad="10px"
                    background="rgba(255,255,255,0.8)"
                    align='center'
                    justify='center'
                >
                    <Text size='14px'> 인물 목록 </Text>
                </Box>
            }
        </>
    );

}

export default PersonList
